export enum PaymentStatus {
  SUCCESS = 1,
  DECLINE = 2,
}
